import { getLocationSelectItemDataById } from '../locations/mockData'
import { getProductSelectItemDataById } from '../products/mockData'
import { getProjectSelectItemDataById } from '../projects/mockData'
import { getListDataFunctionFactory } from '../../modules/getListDataFunctionFactory'
import {
  LocationHardwareStatusIds,
  getLocationHardwareStatusById,
} from '~/services/selectLists/locationHardwareStatii'
import type { ILocationHardwareTenantOwnedItem } from '@/types/location/models'
import type { TEntityId } from '~/types/models'

const locationHardwareTenantOwnedItemListData =
  undefined as unknown as ILocationHardwareTenantOwnedItem[]

export const getLocationHardwareTenantOwnedItemListData =
  getListDataFunctionFactory<ILocationHardwareTenantOwnedItem[]>({
    listData: locationHardwareTenantOwnedItemListData,
    storageKey: 'locationhardwaretenantowneditemlistdata',
    getStartingListData: getStartingLocationHardwareTenantOwnedItemListData,
  })

export async function getLocationHardwareTenantOwnedItemListDataByLocationId(
  id: TEntityId
): Promise<ILocationHardwareTenantOwnedItem[]> {
  const list: ILocationHardwareTenantOwnedItem[] =
    await getLocationHardwareTenantOwnedItemListData()
  if (!list) {
    throw new Error(
      `getLocationHardwareTenantOwnedItemListData returned undefined/null`
    )
  }
  const locationHardwareTenantOwnedItemListData = list.filter(
    (lhtoi) => lhtoi.location.id === id
  )
  if (!locationHardwareTenantOwnedItemListData) {
    throw new Error(
      `Can't find locationHardwareTenantOwnedItemListData '${id}'`
    )
  }
  return locationHardwareTenantOwnedItemListData
}

export async function getStartingLocationHardwareTenantOwnedItemListData(): Promise<
  ILocationHardwareTenantOwnedItem[]
> {
  return [
    {
      id: 'XXTOH0001',
      hrid: 'TOH0001',
      product: await getProductSelectItemDataById('XXPR0007')!,
      location: await getLocationSelectItemDataById('XXL0001')!,
      locationDetail: '2nd floor, Data Closet, Rack 1',
      make: 'Cisco',
      model: 'Catalyst 8300',
      sn: 'JJ38457364783',
      project: await getProjectSelectItemDataById('XXP0002'),
      status: getLocationHardwareStatusById(LocationHardwareStatusIds.ACTIVE),
    },
  ]
}
